import calculusNo from '../resources/no/calculus.json';
import calculusSe from '../resources/se/calculus.json';
import { CalculusLanguageResources } from '../types/CalculusLanguageResources';

export const calculusI18nResources: CalculusLanguageResources = {
  no: { calculus: calculusNo },
  se: { calculus: calculusSe },
};
